<template>
  <db-icon
    id="gps"
    icon="gps"
    icon-custom
    variant=""
    style="
      --icon-font-size: 8rem;
      --icon-font-family: 'icons-32-outline';
      color: #616161;
      --icon-font-weight: 400;
    "
    class="hydrated"
  ></db-icon>
</template>
